import domtoimage from 'dom-to-image';
import { decodeStateToObject, encodeStateToArray } from '../../utils';

export const handleSharingClick = () => {
	navigator.clipboard.writeText(window.location.href);
};

export const handleDownloadRawFreqCSV = (
	rawFrequencyData: { x: string; y: number }[],
) => {
	//eslint-disable-next-line
	const labeledArray = rawFrequencyData.map((entry) => {
		return { label: entry.x, frequency: entry.y };
	});
	return labeledArray;
};

export const handleEmbeddedUrl = () => {
	const originalUrl = window.location.href;
	const filters = originalUrl.split('/#')[1];

	// Escape hatch if there are no filters
	if (!filters) return originalUrl;

	const filteredFilters = decodeStateToObject(filters.substring(1));
	filteredFilters.isEmbedded = true;

	//remove the first character of the filters
	const encodedFilters = encodeStateToArray(filteredFilters);

	const filteredUrl = originalUrl.replace(filters, `?${encodedFilters}`);
	return filteredUrl;
};

export const handleDownloadTrendlineCSV = (
	graphData: {}[],
	yearSpan: number[],
) => {
	const data = graphData;
	const min = yearSpan[0];
	const max = yearSpan[1];
	const rows = [];

	// makes array of years
	rows.push(['anno']);
	for (let i = min; i <= max; i++) {
		rows.push([i]);
	}

	// fills rows with values from JSON
	for (let i = 0; i < data.length; i++) {
		// @ts-ignore
		rows[0].push(data[i].key);
		// @ts-ignore
		const values = data[i].values;
		for (let j = 1; j < rows.length; j++) {
			const yearValue = rows[j][0];
			let isMatch = false;
			let k = 0;
			while (!isMatch && k < values.length) {
				// eslint-disable-next-line eqeqeq
				if (values[k].x == yearValue) {
					// @ts-ignore
					rows[j].push(values[k].y);
					isMatch = true;
				}
				k++;
			}
			if (!isMatch) {
				// @ts-ignore
				rows[j].push(0);
			}
		}
	}
	return rows;
};

export const handleSVGDownload = (graphViewmode: any) => {
	let graph;
	if (graphViewmode === 'galakser') {
		graph = document.querySelector('.force > svg');
	} else if (graphViewmode === 'trendlinjer') {
		graph = document.getElementById('graph-wrapper');
	} else {
		graph = document.querySelector('.rv-xy-plot');
	}
	if (graph) {
		const svgUrl = '';
		domtoimage.toSvg(graph).then((dataUrl) => {
			const link = document.createElement('a');
			link.download = 'graf.svg';
			link.href = dataUrl;
			link.click();
		});
		return svgUrl;
	}
};
